/**
 * Extention for web3.js. Adds the namespace "masternode" to web3.
 * Public API extension
 *
 *
 * Usage:
 *
 * Web3 = require('web3');<br>
 * web3Extension = require('@energi/web3-ext');<br>
 *
 * web3 = new Web3('https://nodeapi.test3.energi.network');<br>
 * web3Extension(web3);<br>
 * result = await web3.masternode.listMasternodes();<br>
 *
 *
 * <br>
 * <i>Copyright (c) 2020 Energi Cryptocurrency - https://energi.world</i><br>
 * BSD-3-Clause License
 *
 *
 * @module masternode.js
 * @extends web3
 * @class web3.masternode
 * @since 0.0.1
*/
var extend = function extend(web3) {
  var toBN = web3.utils.toBN,
      hexToNumber = web3.utils.hexToNumber;

  web3.extend.formatters.outputMasternodeFormatter = function (item) {
    var modifiedItem = {},
        keys;

    if (!item || !item.Enode) {
      return;
    }

    modifiedItem = {};
    keys = Object.keys(item);
    keys.forEach(function (key) {
      var loweredKey = key[0].toLowerCase() + key.substr(1);
      modifiedItem[loweredKey] = key === 'Collateral' ? toBN(item[key]) : item[key];
    });
    return modifiedItem;
  };

  web3.extend({
    property: 'masternode',
    methods: [
    /**
     * Finds the amount collateralized NRG of the specified address.
     * Also returns the last block on which the NRG coins were collateralized.
     *
     * @method collateralBalance
     * @param address {String} the address to lookup for collateral balance
     * @return {Object} with properties: balance {BN} and lastBlock {number}
     * @since 0.4.0
     */
    new web3.extend.Method({
      name: 'collateralBalance',
      call: 'masternode_collateralBalance',
      params: 1,
      inputFormatter: [web3.extend.formatters.inputAddressFormatter],
      outputFormatter: function outputFormatter(status) {
        return {
          balance: toBN(status.Balance),
          lastBlock: hexToNumber(status.LastBlock)
        };
      }
    }),
    /**
     * Returns a list with all announced masternodes.
     *
     * @method listMasternodes
     * @return {Array} with masternodes objects.
     * @since 0.4.0
     */
    new web3.extend.Method({
      name: 'listMasternodes',
      call: 'masternode_listMasternodes',
      params: 0,
      outputFormatter: function outputFormatter(masternode) {
        return web3.extend.formatters.outputMasternodeFormatter(masternode);
      }
    }),
    /**
     * Finds detailed information about a masternode.
     *
     * @method masternodeInfo
     * @param address|masternode {String} the address or masternode to lookup
     * @return {Object} masternode information
     * @since 0.4.0
     */
    new web3.extend.Method({
      name: 'masternodeInfo',
      call: 'masternode_masternodeInfo',
      params: 1,
      inputFormatter: [web3.extend.formatters.inputAddressFormatter],
      outputFormatter: function outputFormatter(status) {
        return web3.extend.formatters.outputMasternodeFormatter(status);
      }
    }),
    /**
     * Retrieves these masternode statistics:
     * active, activeCollateral {BN}, maxOfAllTimes {BN}, total, totalCollateral {BN}
     *
     * @method stats
     * @return {Object} masternode statistics
     * @since 0.4.0
     */
    new web3.extend.Method({
      name: 'stats',
      call: 'masternode_stats',
      params: 0,
      outputFormatter: function outputFormatter(status) {
        return {
          active: status.Active,
          total: status.Total,
          activeCollateral: toBN(status.ActiveCollateral),
          totalCollateral: toBN(status.TotalCollateral),
          maxOfAllTimes: toBN(status.MaxOfAllTimes)
        };
      }
    })]
  });
};

module.exports = extend;